import type { LabelHTMLAttributes, ReactNode } from "react";

export type LabelProps = LabelHTMLAttributes<HTMLLabelElement> & {
  icon?: ReactNode;
};

export const Label = ({
  icon,
  children,
  className = "",
  ...rest
}: LabelProps) => (
  <label
    className={`text-gray-400 text-xs uppercase font-semibold tracking-wider flex items-center gap-1.5 ${className}`}
    {...rest}
  >
    {icon}
    {children}
  </label>
);
